import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import axios from 'axios';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import Button from '@material-ui/core/Button';
// import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import { Card, CardContent, TextField, makeStyles } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import './invoicestyles.css';
import { CommonConfig } from '../../config/common-config';
import token from '../../config/token';
import RazorPay from '../../components/razorPay/index';
import LoaderPopUp from '../../components/loaderpopup/loader';
import SuccessPopUp from '../../components/loaderpopup/success';
import ErrorPopUp from '../../components/loaderpopup/error';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PreviewImage from '../../assets/previewImage.png';
import PreviewModal from '../../components/modal/previewModal';
import Tooltip from '@material-ui/core/Tooltip';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
        fontSize: '15px',
        paddingTop: '15px',
        color: '#5d5d5d',
        fontWeight: '400',
        fontFamily: 'Rubik',
    },
}));

export default function InvoicePayment(props) {
    const tokens = token();
    const classes = useStyles();
    const location = useLocation();
    const invoiceData = location.state.row;
    const [showonlineDiv, setonlineDiv] = useState('block');
    const [showofflineDiv, setofflineDiv] = useState('none');
    const [errormsg, setErrormsg] = useState('');
    const [filename, setFilename] = useState('');
    const [setIsfileInvalid] = useState('');
    // const [setIsDisable] = useState(true);
    const [selectedFileData, setSelectedFileData] = useState(null);
    const [setIsDisableAddFile] = useState(true);
    const [showBtnLoader, setShowBtnLoader] = useState(false);
    const [bankDefaults, setBankDefaults] = useState([]);
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const userTeam = userDetails.result && userDetails.result.data.features[0].team;
    const userDetailsdata = userDetails.result && userDetails.result.data;
    const usertype = userDetailsdata && userDetailsdata.userType;
    console.log('usertype', usertype);
    const date = new Date(invoiceData.invoiceDate);
    const invoiceDate = usertype === 'ADMIN' ? invoiceData.invoiceDate : moment(date).format('DD-MM-YYYY');

    const history = useHistory();
    const [showLoader, setShowLoader] = useState(false);
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const axiosConfig = {
        headers: {
            Authorization: bearerToken,
        },
    };

    const [isDisable, setIsDisable] = useState(true);
    const [URLValue, setURLValue] = useState();
    const [handleOpenNew, setHandleOpenNew] = useState(false);
    const [clearDataNew, setClearDataNew] = useState('');
    const [isfileInvalidNew, setIsfileInvalidNew] = useState('');
    const [selectedFileDataNew, setSelectedFileDataNew] = useState(null);
    const [filenameNew, setFilenameNew] = useState('');
    const [uploadSuccessfullyNew, setUploadSuccessfullyNew] = useState('');
    const [isDisableNew, setIsDisableNew] = useState(true);
    const [attachedFileNew, setAttachedFileNew] = useState('');
    const [visible, setVisible] = React.useState(false);
    const [downloadFile, setDownloadFile] = useState('');
    const [particulars, setParticulars] = useState('');

    // console.log("particulars", particulars)

    const formik = useFormik({
        initialValues: {
            invoiceId: invoiceData.id,
            paymentUrl: '',
            comments: '',
        },
        validationSchema: Yup.object({
            invoiceId: Yup.string().required('Required Field'),
            // paymentUrl: Yup.date().required('Required Field'),
            comments: Yup.string().required('Required Field'),
        }),
        onSubmit: (values) => {
            setShowLoader(true);
            const data = {
                invoiceId: {
                    id: values.invoiceId,
                },
                comments: values.comments,
                paymentUrl: URLValue,
            };
            //console.log('data......', data);

            axios
                .post(
                    `${CommonConfig.dev.baseUrl}/api/auth/generate-offline-payment/${
                    usertype === 'ADMIN' ? '' : tennantDetails.tennantName
                    }`,
                    data,
                    tokens
                )
                .then((response) => {
                    if (response.data) {
                        setShowLoader(false);
                        setSuccessPop(true);
                        setTimeout(() => {
                            {
                                usertype === 'ADMIN'
                                    ? props.history.push('/menu/adminpaymenthistory')
                                    : props.history.push('/menu/paymenthistory');
                                // : props.history.push('/menu/individualpaymenthistory');
                            }
                        }, 3000);
                    }
                })
                .catch((error) => {
                    const errResult = error.response;
                    if (errResult.data) {
                        setShowLoader(false);
                        setErrorPop(true);
                        setTimeout(() => {
                            setErrorPop(false);
                        }, 5000);
                        setErrorMsgGenerateRecceipt(errResult.data.message);
                    }
                });
        },
    });

    useEffect(
        (data) => {
            if (usertype === 'ADMIN') {
                const adminValues = location.state.row;
                setParticulars(adminValues.smapInvoiceParticular);

                console.log('adminValues', adminValues.smapInvoiceParticular);
            } else {
                getParticulars();
            }
            if (invoiceData.totalAmount === null) {
                alert('something wrong');
                history.goBack();
            }
            if (usertype === 'ADMIN') {
                axios
                    .get(`${CommonConfig.dev.baseUrl}/api/auth/s-bankdetails-default`, tokens)
                    .then((response) => {
                        setBankDefaults(response.data);
                    })
                    .catch((error) => {
                        if (error.response.data) {
                        }
                    });
            } else {
                axios
                    .get(`${CommonConfig.dev.baseUrl}/api/auth/bankdetails-default/${tennantDetails.tennantName}`, tokens)
                    .then((response) => {
                        setBankDefaults(response.data);
                    })
                    .catch((error) => {
                        //console.log("error", error);
                        if (error.response.data) {
                        }
                    });
            }
        },

        [tokens]
    );

    const getParticulars = () => {
        console.log('invoiceData.invoiceId', invoiceData.invoiceId);
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/particulars/${tennantDetails.tennantName}/${invoiceData.id}`, tokens)
            .then((response) => {
                // console.log('setParticulars', response);
                setParticulars(response.data);
            })
            .catch((error) => {
                // if (error.response.data) {
                // }
            });
    };

    const handleRoleChange = (event) => {
        switch (event.target.value) {
            case 'online':
                setonlineDiv('block');
                setofflineDiv('none');
                return true;
            case 'offline':
                setonlineDiv('none');
                setofflineDiv('block');
                return true;
            default:
                return true;
        }
    };

    const isFileUpload = (event, selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('([a-zA-Z0-9s_\\.-:])+(.pdf)$');
            setFilename(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalid('');
                setIsDisable(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalid('Please select the file size less than 10MB');
                    setIsDisable(true);
                } else {
                    setSelectedFileData(selectorFiles[0]);
                    setIsDisableAddFile(false);
                }
            } else {
                setIsfileInvalid('Please select valid file format i.e pdf');
                setIsDisable(true);
            }
        }
    };

    const handleCloseNew = () => {
        setHandleOpenNew(false);
        setIsfileInvalidNew('');
        setUploadSuccessfullyNew('');
    };
    const handleClickNew = () => {
        //console.log('aaaa')
        setHandleOpenNew(true);
        setClearDataNew('');
        setFilenameNew('');
        setIsDisableNew(true);
    };
    const isFileUploadNew = (event, selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(png|jpeg|jpg|pdf)$');
            setFilenameNew(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalidNew('');
                setIsDisableNew(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalidNew('Please select the file size less than 10MB');
                    setIsDisableNew(true);
                } else {
                    setSelectedFileDataNew(selectorFiles[0]);
                }
            } else {
                setIsfileInvalidNew('Please select valid file format i.e pdf');
                setIsDisableNew(true);
            }
        }
    };

    const fileUploadNew = () => {
        const data = new FormData();
        data.append('file', selectedFileDataNew);
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload/${tennantDetails.tennantName}/111/myimage`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data) {
                    setURLValue(response.data);
                    const filename = response.data.substring(response.data.lastIndexOf('/') + 1);
                    setAttachedFileNew(filename);
                    setUploadSuccessfullyNew('Uploaded a file successfully');
                    setIsDisable(false);
                    setTimeout(() => {
                        handleCloseNew();
                    }, 500);
                }
            })
            .catch((error) => {
                //console.log("ravi", error);
                // if (error === "Error: Network Error") {
                //     //console.log("Error: Network Error");
                // }

                let errorResponse = error.response;
                let dataResponse = errorResponse && errorResponse.data;
                if (dataResponse) {
                    setIsDisableNew(true);
                } else {
                    //console.log("Error: Network Error");
                }
            });
    };

    const handleModalClose = () => {
        setVisible(false);
    };

    const handlePreviewModal = (file) => {
        setDownloadFile(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`);
        setTimeout(() => {
            setVisible(true);
        }, 1000);
    };

    //append comma
    function numberWithCommas(x) {
        x = x.toString();
        const IndianCur = new Intl.NumberFormat('en-IN').format(parseFloat(x.replace(/,/g, '')));
        return IndianCur;
    }

    const razorPayPropsObject = {
        postInvoiceIdUrl: `${CommonConfig.dev.baseUrl}/api/auth/generate-online-payment/${invoiceData.id}`,
        bearerToken: tokens,
        updatePaymentUrl: `${CommonConfig.dev.baseUrl}/api/auth/update-online-payment`,
    };
    const razorPayPropsObjectClient = {
        postInvoiceIdUrl: `${CommonConfig.dev.baseUrl}/api/auth/generate-online-payment/${invoiceData.id}/${tennantDetails.tennantName}`,
        bearerToken: tokens,
        updatePaymentUrl: `${CommonConfig.dev.baseUrl}/api/auth/update-online-payment/${tennantDetails.tennantName}`,
    };
    const navigate = () => {
        if (usertype === "INDIVIDUAL") {
            history.push('/menu/MyInvoices');
        } else {
            history.push('/menu/itecservice-invoice');
        }
    };
    return (
        <>
            {showLoader ? <LoaderPopUp showLoader={showLoader} /> : null}
            {successpop ? <SuccessPopUp open={successpop} showSuccess={successpop} title="Payment done successfully" /> : null}
            {errorpop ? <ErrorPopUp open={errorpop} showError={errorpop} title={errorMsgGenerateRecceipt} /> : null}
            <form className="itecform" onSubmit={formik.handleSubmit}>
                <Card className="client-card">
                    <CardContent className="client-heading">
                        <Typography variant="h5">Tax Invoice</Typography>
                    </CardContent>
                    <CardContent>
                        <Grid container spacing={3} className="main-container">
                            <Grid item xs={12} sm={6}>
                                <div className="invoice-leftdiv">
                                    <span className="particulars">
                                        {' '}
                                        <span> Invoice No : {invoiceData.invoiceNumber} </span>{' '}
                                    </span>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div className="invoice-rightdiv">
                                    <span className="particulars">
                                        <span>Date : {invoiceDate} </span>
                                    </span>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <p className="particulars">
                                        {' '}
                                        <span> Description : </span>{' '}
                                    </p>
                                    {particulars &&
                                        particulars.length > 0 &&
                                        particulars &&
                                        particulars.map((value, index) => (
                                            <span>
                                                <span style={{ marginRight: '5px', marginLeft: '15px' }}>{index + 1}.</span>
                                                <span>{value.particularsText}</span>

                                                {value.description ? (
                                                    <span>{value.description !== '' ? '(' + value.description + ')' : ''}</span>
                                                ) : null}
                                            </span>
                                        ))}
                                    {/* <span className="particulars">{particulars.description}</span> */}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <p className="particulars">
                                        {' '}
                                        <span>Amount to pay : </span>{' '}
                                    </p>
                                    <p className="particulars bolder">{numberWithCommas(invoiceData.totalAmount)}</p>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <ul className="genderli radioalignment">
                                        <li>
                                            <div className="custom-control">
                                                <input
                                                    id="online"
                                                    type="radio"
                                                    onChange={handleRoleChange}
                                                    value="online"
                                                    name="mode"
                                                    defaultChecked="true"
                                                />
                                                <label className="custom-control-label" htmlFor="online">
                                                    Pay online
                                                </label>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="custom-control">
                                                <input id="offline" type="radio" value="offline" onChange={handleRoleChange} name="mode" />
                                                <label className="custom-control-label" htmlFor="offline">
                                                    Pay offline
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid></Grid>
                        <Grid item xs={12} sm={12}>
                            <div className="offlinediv" style={{ display: showofflineDiv }}>
                                <hr className="invoicedividertag" />

                                <Grid item xs={12} sm={12}>
                                    <div className="subtitle">Transfer money to the below account details</div>
                                    <div className="dividerinvoicediv offlinedivider" />
                                </Grid>
                                {bankDefaults &&
                                    bankDefaults.map((bankDetails) => {
                                        return (
                                            <Grid item xs={12} sm={12}>
                                                <FormControl fullWidth>
                                                    <div className="particulars">
                                                        Bank Name : <span> {bankDetails.bankName}</span>{' '}
                                                    </div>
                                                </FormControl>

                                                <FormControl fullWidth>
                                                    <div className="particulars">
                                                        A/c No : <span> {bankDetails.accountNumber} </span>
                                                    </div>
                                                </FormControl>

                                                <FormControl fullWidth>
                                                    <div className="particulars">
                                                        Branch & IFSC Code :{' '}
                                                        <span>
                                                            {bankDetails.branch} & {bankDetails.ifscCode}
                                                        </span>
                                                    </div>
                                                </FormControl>
                                            </Grid>
                                        );
                                    })}

                                <Grid item xs={12} sm={4} className="intermediarybtnfontsize">
                                    <div className="buttonwidth">
                                        <FormControl fullWidth>
                                            <label htmlFor="raised-button-file">
                                                <Button
                                                    onClick={handleClickNew}
                                                    className="intermediarybtn"
                                                    variant="outlined"
                                                    component="label"
                                                    color="primary"
                                                >
                                                    Add acknowledgement
                                                    <span style={{ color: '#ff0a047a' }}>*</span>
                                                </Button>
                                                {attachedFileNew ? (
                                                    <span
                                                        style={{ marginLeft: '7px', marginRight: '7px', paddingTop: '7px' }}
                                                        className="fileName"
                                                    >
                                                        {attachedFileNew.substring(0, 15)}
                                                        {attachedFileNew.length > 15 ? '...' : ''}
                                                    </span>
                                                ) : null}
                                                {attachedFileNew ? (
                                                    <span onClick={() => handlePreviewModal(URLValue)}>
                                                        <Tooltip title="Preview">
                                                            <img src={PreviewImage} alt="PreviewImage" className="fileView" />
                                                        </Tooltip>
                                                    </span>
                                                ) : null}
                                                <Dialog
                                                    onClose={handleCloseNew}
                                                    PaperProps={{
                                                        className: 'QandADailogBox',
                                                        style: { padding: '20px' },
                                                    }}
                                                    aria-labelledby="form-dialog-title"
                                                    open={handleOpenNew}
                                                    clear={clearDataNew}
                                                >
                                                    <DialogTitle id="form-dialog-title">Upload File</DialogTitle>
                                                    <DialogContent style={{ textAlign: 'center' }}>
                                                        <Button className="btnOrange" variant="outlined" component="label" color="default">
                                                            <i className="btnIcon">
                                                                <FontAwesomeIcon icon={faPlus} />
                                                            </i>{' '}
                                                            Add File
                                                            <input
                                                                onChange={(e) => isFileUploadNew(e, e.target.files)}
                                                                type="file"
                                                                style={{ display: 'none' }}
                                                                accept=".jpeg,.png,.csv,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                                                            />
                                                        </Button>
                                                        <p className="fileName">{filenameNew}</p>
                                                    </DialogContent>
                                                    <p className="fileNameGreen">{uploadSuccessfullyNew}</p>
                                                    <DialogActions className="paddingBtm txtCenter">
                                                        <Button
                                                            className={isDisableNew ? 'disableBtn' : 'btnBluepop'}
                                                            onClick={fileUploadNew}
                                                            variant="contained"
                                                            disabled={isDisableNew}
                                                            component="label"
                                                            color="default"
                                                        >
                                                            Upload
                                                        </Button>
                                                        <Button
                                                            className="btnBluepop"
                                                            disabled={uploadSuccessfullyNew.length}
                                                            onClick={handleCloseNew}
                                                            variant="contained"
                                                            component="label"
                                                            color="default"
                                                        >
                                                            Cancel
                                                        </Button>
                                                    </DialogActions>
                                                </Dialog>
                                            </label>
                                            <PreviewModal
                                                fileSource={downloadFile}
                                                visibleClose={visible}
                                                handleModalClose={handleModalClose}
                                            />
                                        </FormControl>
                                    </div>
                                    {/* <span style={{ color: '#ff0a047a' }}>* Mandatory should attach a file</span> */}
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <Typography className="particulars mt15">
                                        <span>Enter Comments </span>
                                        <span style={{ color: '#ff0a047a' }}>*</span>
                                    </Typography>
                                    <FormControl fullWidth className="bottom">
                                        <TextField
                                            name="comments"
                                            type="text"
                                            className="comments"
                                            InputProps={{
                                                classes: { root: classes.bottomLine },
                                            }}
                                            multiline
                                            rows={3}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.comments}
                                        />
                                        {formik.touched.comments && formik.errors.comments ? (
                                            <span className="itec-validationError">{formik.errors.comments}</span>
                                        ) : null}
                                    </FormControl>

                                    <p className="errorMsg">{errormsg}</p>
                                </Grid>
                            </div>
                        </Grid>
                    </CardContent>
                </Card>

                <div className="footer-button">
                    <ul>
                        <li>
                            <span style={{ display: showonlineDiv }} onClick={navigate}>
                                <Button type="submit" className="bckBtn" style={{ fontWeight: 'normal !important' }}>
                                    Back
                                </Button>
                            </span>
                        </li>
                        <li>
                            <span style={{ display: showonlineDiv }}>
                                <RazorPay
                                    razorPayProps={userTeam === 'Ultimate Client' ? razorPayPropsObjectClient : razorPayPropsObject}
                                />
                            </span>
                        </li>
                        <li>
                            <span style={{ display: showofflineDiv }}>
                                {showBtnLoader ? <LoaderPopUp showLoader={showLoader} /> : null}
                                <Button color="primary" type="submit" className="txt-capitalize btnBlue" disabled={isDisable}>
                                    Submit
                                </Button>
                            </span>
                        </li>
                    </ul>
                </div>
            </form>
        </>
    );
}
